import { render, staticRenderFns } from "./MpGuid.vue?vue&type=template&id=1afa9a99&scoped=true&"
import script from "./MpGuid.vue?vue&type=script&lang=js&"
export * from "./MpGuid.vue?vue&type=script&lang=js&"
import style0 from "./MpGuid.vue?vue&type=style&index=0&id=1afa9a99&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa9a99",
  null
  
)

export default component.exports